import { Component, OnInit } from '@angular/core';
import { Partner } from '../models/partner';
import { PartnerRelationship } from '../models/PartnerRelationship';
import { Message } from 'primeng/api';

@Component({
  selector: 'app-manage-partnership',
  templateUrl: './manage-partnership.component.html',
  styleUrls: ['./manage-partnership.component.scss']
})
export class ManagePartnershipComponent implements OnInit {

  displayAddDialog = false;
  relationships: PartnerRelationship[];
  messages: Message[] = [];

  constructor() { }

  ngOnInit() {
  }

  showAddDialog(): void {
    this.displayAddDialog = true;
  }

  addDialogClose(display: boolean): void {
    this.displayAddDialog = display;
  }

  refreshRelationships(relationships: PartnerRelationship[]): void {
    this.relationships = relationships;
  }

  errorMessage(message: string) {
    this.messages = [{severity: 'error', summary: message, detail: ''}];
  }
}
